import { useSubmitPositionV2 } from '@/clients/position/useSubmitPosition.ts';
import { FunctionComponent } from 'react';
import { constructPositionConfiguration } from '@/modules/position/components/PositionSummary/utils/constructPositionConfiguration.ts';
import { FinanceSettingsFormRendererProps } from '@/modules/position/components/PositionSummary/PositionSummary.tsx';

type CreatePositionSummaryProps = {
    FinanceSettingsFormRenderer: FunctionComponent<FinanceSettingsFormRendererProps>;
};

export const CreatePositionSummary = ({ FinanceSettingsFormRenderer }: CreatePositionSummaryProps) => {
    const { mutateAsync, isPending, isSuccess } = useSubmitPositionV2();

    const handleSubmit = async (positionConfiguration: ReturnType<typeof constructPositionConfiguration>) => {
        const createdPosition = await mutateAsync(positionConfiguration);

        return {
            id: createdPosition.id,
            positionNumber: createdPosition.projectPositionNumber,
        };
    };

    return <FinanceSettingsFormRenderer isSuccess={isSuccess} isPending={isPending} onSubmit={handleSubmit} />;
};
